import { Link } from "react-router-dom";
import "../styles/report.css";
import "../styles/reportPrint.css";
import { META, FRAMING, TOC_ITEMS, REASSURANCE_QUOTE } from "../data/reportContent";
import { ReportBody } from "../components/report/ReportBody";

export default function ReportPrint() {
  return (
    <div className="report-root print-mode" data-testid="report-print-page">
      <div className="print-toolbar no-print" data-testid="print-toolbar">
        <div>
          <Link to="/report" className="btn-ghost" data-testid="print-back-link">
            ← Back to web report
          </Link>
        </div>
        <div className="print-toolbar-actions">
          <span className="print-toolbar-note">
            For a clean PDF, keep “Headers and footers” switched OFF in your browser’s print dialog; page numbers are already built into this document.
          </span>
          <button className="btn-primary" onClick={() => window.print()} data-testid="print-now-button">
            Print / Save PDF
          </button>
        </div>
      </div>

      <section className="print-cover" data-testid="print-cover">
        <div className="print-cover-top">
          <span className="report-kicker">{META.edition} · {META.date} · Print Edition</span>
          <h1 data-testid="print-cover-title">{META.title}</h1>
          <p className="subtitle">{META.subtitle}</p>
          <p className="framing">{FRAMING}</p>
          <p className="print-cover-reassurance" data-testid="print-cover-reassurance">{REASSURANCE_QUOTE}</p>
        </div>

        <div className="print-cover-contents" data-testid="print-cover-contents">
          <div className="print-cover-contents-title">Contents</div>
          <ol>
            {TOC_ITEMS.map((item) => (
              <li key={item.id}>{item.label}</li>
            ))}
          </ol>
        </div>

        <div className="print-cover-bottom">
          <span>{META.provenance}</span>
          <span>{META.copyright}</span>
        </div>
      </section>

      <ReportBody />

      <footer className="report-footer" data-testid="print-report-footer">
        <span>{META.title}: {META.subtitle}</span>
        <span>{META.edition} · {META.date}</span>
        <span>{META.provenance}</span>
        <span data-testid="print-copyright">{META.copyright}</span>
      </footer>
    </div>
  );
}
